import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { Box, Button, Card, Checkbox, FormControlLabel, Typography } from '@mui/material'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { DOMAIN, api } from '../../utils/api'
import { getFromStorage } from '../../utils/storage'
import { handleError } from '../../utils/error'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, loadingActions } from '../../redux/store'
import Loading from '../../components/Loading'
import SecurityIcon from '@mui/icons-material/Security'
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser'
import { mainGreen, mainGrey, mainRed } from '../../utils/color'

export default function EditAuthorization() {
	const { isLoading } = useSelector((state) => state.isLoading)
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { roleId } = useParams()
	const token = getFromStorage('current-user')?.accessToken
	const [role, setRole] = useState()
	const [actions, setActions] = useState([])
	const [actionCheck, setActionCheck] = useState([])
	const [actionVN, setActionVN] = useState([])

	const getRole = useCallback(
		async function () {
			dispatch(loadingActions.isLoading())
			try {
				const response = await axios({
					url: `${DOMAIN}/admin/role/${roleId}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRole(response.data)
				setActionCheck(response.data.permission)
				setActionVN(response.data.permissionVN)
				dispatch(loadingActions.isLoaded())
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, roleId, dispatch, navigate],
	)

	useEffect(() => {
		getRole()
	}, [getRole])

	const updatePermission = async () => {
		try {
			const response = await axios({
				url: `${DOMAIN}/admin/edit-role/${roleId}`,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'PUT',
				data: {
					permission: actionCheck,
					permissionVN: actionVN,
				},
				withCredentials: true,
			})
			alert(response.data.message)
			navigate('/admin/roles')
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const getActions = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_ACTIONS_ADMIN,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				response.data.forEach((action) => {
					actionCheck?.forEach((actionCheck) => {
						if (action.name === actionCheck) {
							action.checked = true
						}
					})
				})
				setActions(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token, actionCheck],
	)

	useEffect(() => {
		getActions()
	}, [getActions])

	const handleChange = (e) => {
		let { value, checked } = e.target
		if (checked === true) {
			setActionCheck([...actionCheck, value])
			actions.forEach((action) => {
				if (action.name === value) {
					setActionVN([...actionVN, action.desc])
				}
			})
		} else {
			actions.forEach((action) => {
				if (action.name === value) {
					setActionVN(actionVN?.filter((actionVN) => actionVN !== action.desc))
				}
			})
			setActionCheck(actionCheck?.filter((action) => action !== value))
		}
	}
	return (
		<UserLayout>
			{isLoading ? (
				<Loading />
			) : (
				<Box
					sx={{
						maxWidth: 992,
						marginLeft: 'auto',
						marginRight: 'auto',
					}}>
					<Card sx={{ padding: '20px' }}>
						<Box
							sx={{
								background: mainGrey,
								color: '#fff',
								padding: ' 10px',
								borderRadius: '5px',
							}}>
							<Typography
								sx={{
									background: mainRed,
									display: 'inline-flex',
									alignItems: 'center',
									padding: '2px 10px',
									borderRadius: '5px',
									mt: 1,
									mb: 1,
								}}>
								<SecurityIcon sx={{ marginRight: '3px', fontSize: '20px' }} />
								Quyền hạn {role?.description} hiện tại
							</Typography>

							{role?.permissionVN?.map((permissionVN, index) => {
								return (
									<p
										style={{
											textAlign: 'left',
											margin: 0,
											color: '#000',
										}}
										key={index}>
										<span style={{ fontWeight: 'bold' }}>*</span> {permissionVN}
									</p>
								)
							})}
							<Typography
								sx={{
									background: mainGreen,
									display: 'inline-flex',
									alignItems: 'center',
									padding: '2px 10px',
									borderRadius: '5px',
									mt: 1,
									mb: 1,
								}}>
								<VerifiedUserIcon sx={{ marginRight: '3px', fontSize: '20px' }} />
								Quyền hạn cập nhật
							</Typography>
							{actionVN?.map((permissionVN, index) => {
								return (
									<p
										style={{
											textAlign: 'left',
											margin: 0,
											color: '#000',
										}}
										key={index}>
										<span style={{ fontWeight: 'bold' }}>*</span> {permissionVN}
									</p>
								)
							})}
						</Box>
						{actions?.map((action, index) => {
							return (
								<FormControlLabel
									key={index}
									control={
										<Checkbox
											onClick={(e) => {
												e.stopPropagation()
											}}
											checked={action.checked || false}
											value={action.name}
											onChange={handleChange}
											sx={{ color: mainGreen }}
										/>
									}
									label={action.desc}
								/>
							)
						})}
						<Button
							sx={{
								mt: 1,
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							onClick={() => {
								const confirm = window.confirm('Bạn có chắc cập nhật quyền hạn cho vị trí này?')
								if (confirm) {
									updatePermission()
								}
							}}
							fullWidth
							size='small'
							variant='contained'>
							Xác nhận
						</Button>
					</Card>
				</Box>
			)}
		</UserLayout>
	)
}
